/** @format */

import * as React from "react";
import Avatar from "@mui/material/Avatar";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Stack from "@mui/material/Stack";
import type { SxProps } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { Wallet } from "@phosphor-icons/react/dist/ssr/Wallet";
import { formatCurrency } from "../../../utility/currencyUtils";

export interface TotalPayoutsHistoryProps {
	sx?: SxProps;
	totalPayoutAmount: number;
	totalPayouts: number;
}

export function TotalPayoutsHistory({
	sx,
	totalPayoutAmount,
	totalPayouts,
}: TotalPayoutsHistoryProps): React.JSX.Element {
	return (
		<Card sx={sx}>
			<CardContent>
				<Stack spacing={3}>
					<Stack
						direction="row"
						sx={{ alignItems: "flex-start", justifyContent: "space-between" }}
						spacing={3}>
						<Stack spacing={1}>
							<Typography color="text.secondary" variant="overline">
								All-Time Payouts
							</Typography>
							<Typography variant="h4">
								{formatCurrency(totalPayoutAmount, "usd")}
							</Typography>
						</Stack>
						<Avatar
							sx={{
								backgroundColor: "#059669",
								height: "56px",
								width: "56px",
							}}>
							<Wallet size={24} color="#ffffff" />
						</Avatar>
					</Stack>
					<Stack direction="row" spacing={1} alignItems="center">
						<Typography variant="body2" color="text.secondary">
							{totalPayouts.toLocaleString()} total payouts distributed
						</Typography>
					</Stack>
				</Stack>
			</CardContent>
		</Card>
	);
}
